import React, { useState } from "react";
import "../assets/OnboardLicense.css";
import { postFormData } from "../api/restapi";
import Select from "react-select";
import Popup from "../popups/popup";
import ConfirmationDialog from "../popups/ConfirmationDialog";

function GroupTab() {
  const [inputText, setInputText] = useState("");
  const groupDigits = Array.from({ length: 10 }, (_, i) => ({ value: i, label: i.toString() }));
  const [selectedGroupDigits, setSelectedGroupDigits] = useState([]);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const handleSubmit = () => {
    setShowConfirmation(true);
  };

  const handleConfirm = () => {
    const formData = new FormData();
    formData.append("groupName", inputText);
    formData.append("selectorIds", selectedGroupDigits.map(groupDigits => groupDigits.value).join(","));

    postFormData("/qfm/v1/solutions/group", formData)
      .then((response) => {
        if (response.error) {
          setErrorMessage(response.error);
        } else {
          setSuccessMessage("Created Group Successfully!");
        }
      })
      .catch((err) => setErrorMessage("There was an error encountered: " + err.message));

    setShowConfirmation(false);
  };

  const handleCancel = () => {
    setShowConfirmation(false);
  };

  const closePopup = () => {
    setSuccessMessage("");
    setErrorMessage("");
    window.location.reload();
  };

  return (
    <div className="lsn-tab-container">
      <div className="tab-heading">
        <h1>IMEI Based Group</h1>
      </div>

      <div className="row">
        <div className="dropdown-section">
          <div className='dropdown-heading'>Last Digit of IMEI<span className="required-asterisk">*</span></div>
          <Select
            className="dropdown multi-select"
            options={groupDigits}
            isMulti
            value={selectedGroupDigits}
            onChange={setSelectedGroupDigits}
            placeholder="Select..."
          />
        </div>

        <div className="dropdown-section">
          <div className='dropdown-heading'>Description<span className="required-asterisk">*</span></div>
          <input
            className="lsn-description"
            type="text"
            placeholder="Enter text"
            value={inputText}
            onChange={(e) => setInputText(e.target.value)}
          />
        </div>
      </div>

      <div className='submit-button-section'>
        <button className="submit-button" onClick={handleSubmit}>Create Group</button>
      </div>

      {showConfirmation && (
        <ConfirmationDialog
          message={`Are you sure you want to onboard the following Group?\n\nGroup Description: ${inputText || "None"}\nLast digits for IMEI selected: ${selectedGroupDigits.map(groupDigits => groupDigits.value).join(",")}`}
          onConfirm={handleConfirm}
          onCancel={handleCancel}
        />
      )}

      {successMessage && (
        <Popup message={successMessage} onClose={closePopup} />
      )}

      {errorMessage && (
        <Popup message={errorMessage} onClose={closePopup} />
      )}
    </div>
  );
}

export default GroupTab;
